export const getFilterType = function(params) {
    return this.axiosIns
        .get('/api-site/search/filterType', {
            params
        })
        .then(data => data.data);
};
